import { MijnRoute } from '../../mijn-navigatie.model';

export const SELF_SERVICE_AUTH_TOKENS: MijnRoute = {
    path: 'inlogmiddelen-beheren',
    navigationEvent: 'toTokenBeheer',
    regex: /^\/zelf-regelen\/inlogmiddelen-beheren$/,
    webcomponent: 'mijn-tokens-beheer-webcomponent'
};
